<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center"
            role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label class="form-label">Type</label>
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="type_organisation" type="radio" name="type"
                            [(ngModel)]="item['type']" [value]="'organisation'">
                        <label class="form-check-label" for="type_organisation">Organisatie</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="type_individual" type="radio" name="type"
                            [(ngModel)]="item['type']" [value]="'individual'">
                        <label class="form-check-label" for="type_individual">Individu</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Verzender naam</label>
                <input [ngClass]="{'is-invalid': errors['sender_name']}" type="text" [(ngModel)]="item['sender_name']"
                    class="form-control" placeholder="Verzenden naam">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Verzender e-mail</label>
                <input [ngClass]="{'is-invalid': errors['sender_email']}" type="text" [(ngModel)]="item['sender_email']"
                    class="form-control" placeholder="Verzenden e-mail">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Onderwerp</label>
                <input [ngClass]="{'is-invalid': errors['subject']}" type="text" [(ngModel)]="item['subject']"
                    class="form-control" placeholder="Onderwerp">
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Content</label>
                <div id="editorjs"></div>
            </div>
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="!item['id']">Toevoegen</span>
                <span *ngIf="item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>